import React from 'react';
import PropTypes from 'prop-types';

export default class SuggestedWordTextItem extends React.Component {

  static propTypes = {
    suggestedWordText: PropTypes.string,
    index: PropTypes.number,
    currentIndex: PropTypes.number,
    downshiftItemProps: PropTypes.func
  }

  render() {
    return(
      <div
        {...this.props.downshiftItemProps({
          key: this.props.index,
          index: this.props.index,
          item: this.props.suggestedWordText,
          className: this.suggestedWordClassName(),
        })}
      >
        {this.props.suggestedWordText}
      </div>
    );
  }

  suggestedWordClassName() {
    if (this.props.index == this.props.currentIndex) {
      return 'highlighted suggested-search-item';
    } else {
      return 'suggested-search-item'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/suggested_word_text_item.jsx